var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEftpos64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EFTPOS-Pictogram_64x64px_Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.000000, 6.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2941176,2.75 C32.3865044,2.75 33.375475,3.19277721 34.0913489,3.90865112 C34.8072228,4.62452502 35.25,5.61349561 35.25,6.70588235 L35.25,6.70588235 L35.25,47.2941176 C35.25,48.3865044 34.8072228,49.375475 34.0913489,50.0913489 C33.375475,50.8072228 32.3865044,51.25 31.2941176,51.25 L31.2941176,51.25 L4.70588235,51.25 C3.61349561,51.25 2.62452502,50.8072228 1.90865112,50.0913489 C1.19277721,49.375475 0.75,48.3865044 0.75,47.2941176 L0.75,47.2941176 L0.75,6.70588235 C0.75,5.61349561 1.19277721,4.62452502 1.90865112,3.90865112 C2.62452502,3.19277721 3.61349561,2.75 4.70588235,2.75 L4.70588235,2.75 L31.2941176,2.75 Z",
    id: "Rectangle",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 4.75,
    y: 6.75,
    width: 26.5,
    height: 26.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,-13.1968317 L19.3846433,-9.14106073 C19.6215028,-8.83459903 19.75,-8.45821687 19.75,-8.07089113 L19.75,-8.07089113 L19.75,10.0983049 C19.75,10.489091 19.6191999,10.8686331 19.3784436,11.1764483 L19.3784436,11.1764483 L16.25,15.1762713 L16.25,-13.1968317 Z",
    id: "Path-9",
    strokeWidth: 1.5,
    fill: "#FFCC00",
    transform: "translate(18.000000, 1.000000) rotate(-90.000000) translate(-18.000000, -1.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "card",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 16,
    y: 12,
    width: 24.6,
    height: 15.6,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.65,12 L38.8,12 C39.7941125,12 40.6,12.8058875 40.6,13.8 L40.6,25.8 C40.6,26.7941125 39.7941125,27.6 38.8,27.6 L35.65,27.6 L35.65,27.6 L28,19.8 L35.65,12 Z",
    id: "focus",
    strokeWidth: 1.5,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    fill: "#FFFFFF",
    points: "20.8 15 22.6 16.8 20.8 18.6 19 16.8160514"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEftpos64);
export default __webpack_public_path__ + "static/media/pictogramEFTPOS64.5a3491e3d0ee63a40fe806eb72e84ca9.svg";
export { ForwardRef as ReactComponent };